<template>
    <b-modal ref="fixed-expense-type-add-edit-view-modal" :title="fixedExpenseType.id==null? $t('finance.ipoteka.fixedExpenses.expenseTypeAdd'): $t('finance.ipoteka.fixedExpenses.expenseTypeEdit')"
             @ok="save($event)"
             :ok-title="$t('action.save')"
             :no-close-on-backdrop="true"
             :no-close-on-esc="true"
             :ok-disabled="!changeable">
        <div class="">
            <Loading v-if="loading"></Loading>
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col col-12">
                            <div class="form-group">
                                <label>{{$t('common.name')}}: <span class="red">*</span></label>
                                <input type="text" class="form-control"
                                       v-model="fixedExpenseType.name"
                                       :placeholder="$t('common.name')"
                                       :class="{invalid : $v.fixedExpenseType.name.$error}">
                                <div class="red" v-if="$v.fixedExpenseType.name.$error">
                                    {{$t('common.name')}}
                                </div>
                            </div>
                        </div>
                        <div class="col col-12">
                            <div class="form-group">
                                <label>{{$t('common.code')}}: <span class="red">*</span></label>
                                <input type="text" class="form-control" :placeholder="$t('common.code')"
                                       v-model="fixedExpenseType.code"
                                       :class="{invalid : $v.fixedExpenseType.code.$error}">
                                <div class="red" v-if="$v.fixedExpenseType.code.$error">
                                    {{$t('common.name')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-sm-12">
                    <div class="form-group">
                        <label>{{$t('common.comment')}}:</label>
                        <textarea
                                cols="30" rows="3"
                                class="form-control"
                                v-model="fixedExpenseType.description"
                                :placeholder="$t('common.comment')"
                        ></textarea>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>

</template>

<script>
    // import {required, /*requiredUnless, requiredIf*/} from 'vuelidate/lib/validators';
    import {required, /*minValue, minLength*/} from 'vuelidate/lib/validators';
    import initFilterModel from '@/shared/filter';
    import Loading from "@/components/Loading";
    import bModal from 'bootstrap-vue/es/components/modal/modal'


    export default {
        name: "FixedExpenseTypeAddEditView",
        components: {
            Loading,
            bModal
        },
        props: {
            placeholder: String,
            value: Object,
            readonly: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                regionFilter: initFilterModel(),
                focused: false,
                addressValue: null,
                showModalTable: false,
                fixedExpenseType: {
                    id: null,
                    name: null,
                    code: null,
                    comment: null
                },
                loading: false,
                changeable: true
            }
        },
        mounted() {
            // console.log(this.parentData);
            setTimeout(() => {
                console.log(this.$props.value);
                if (this.$props.value) {
                    this.fixedExpenseType = this.$props.value;
                }
            }, 1000);

        },
        validations() {
            return {
                fixedExpenseType: {
                    name: {
                        required: required
                    },
                    code: {
                        required: required
                    },
                }
            }
        },
        methods: {
            save($event) {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    $event.preventDefault();
                    return;
                }
                this.loading = true;
                this.$http.post('fixed-expense-type/save', this.fixedExpenseType)
                    .then(res => {
                        console.log(res.data.data);
                        this.$swal({
                            title: this.$t('messages.common.success'),
                            text: this.$t('messages.common.saved'),
                            type: 'success'
                        });
                        this.loading = false;
                        this.$eventBus.$emit('refreshFixedExpenseTypeList', {data: res.data.data, isNew: this.fixedExpenseType.id==null});
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.common.errorOccurred'),
                            type: 'error'
                        });
                        this.loading = false;
                    });


            },
            init(/*address*/) {

            },
        },
        created() {
            this.$eventBus.$on('showFixedExpenseTypeAddEditView', (data) => {
                if (data.code === 'edit') {
                    this.loading = true;
                    this.$http.get('fixed-expense-type/view/' + data.id)
                        .then(res => {
                            this.fixedExpenseType = res.data;
                            this.loading = false;
                            this.changeable = true;
                            this.$refs['fixed-expense-type-add-edit-view-modal'].show();
                        }, err => {
                            console.log(err);
                            this.loading = false;
                        });
                } else if (data.code === 'view') {
                    this.loading = true;
                    this.$http.get('fixed-expense-type/view/' + data.id)
                        .then(res => {
                            this.fixedExpenseType = res.data;
                            this.loading = false;
                            this.changeable = false;
                            this.$refs['fixed-expense-type-add-edit-view-modal'].show();
                        }, err => {
                            console.log(err);
                            this.loading = false;
                        });
                }
                else if (data.code === 'add') {
                    this.fixedExpenseType = {};
                    this.changeable = true;
                    this.$refs['fixed-expense-type-add-edit-view-modal'].show();
                }
            })
        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>